import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';

declare const toastr: any;

@Component({
    selector: 'multiselect-with-select-field',
    templateUrl: 'multiselect-with-select-field.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MultiselectWithSelectFieldComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => MultiselectWithSelectFieldComponent), multi: true }
    ]
})
export class MultiselectWithSelectFieldComponent extends AbstractFieldClass {
    @Input('value') _value: any = [];
    @Input('data') _data: any = [];
    @Output() delete: EventEmitter<any> = new EventEmitter<any>();
    multiselectSettings = {
        singleSelection: false,
        text: 'Select',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true
    };
    selectValues = [
        {name: 'day', displayName: 'Per Day'},
        {name: 'week', displayName: 'Per Week'},
        {name: 'month', displayName: 'Per Month'},
        {name: 'year', displayName: 'Per Year'}
    ];

    constructor() { super(); }

    get data() { return this._data; }

    set data(val) {
        this._data = typeof val === 'string' ? val.trim() : val;
        this.propagateChange(this._data);
    }

    validator(value: any): boolean { return true; }

    apply(): void{
        if(this.value.limitedPassTypes && this.value.limitedPassTypes.length > 1 && this.value.limitCount && this.value.limitSequenceType) {
            if(parseInt(this.value.limitCount) > 0)
                super.apply();
            else
                toastr.warning('Limit count can\'t be less than 1');
        } else if(this.value.limitedPassTypes && this.value.limitedPassTypes.length < 2)
            toastr.warning('Minimum 2 pass types must be chosen.');
        else
            toastr.warning('All details must be filled before submitting.');
    }

    remove() {
        if (!this.editOnly) {
            this.editModeOff();
            this.delete.emit();
        }
    }

    public validateValue(event) {
        return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 0;
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/fields/multiselect-with-select-field/multiselect-with-select-field.component.ts